import React, { useEffect } from "react";
import styled from 'styled-components';
import Header from '../../components/common/header/Header';
import Footer from '../../components/common/Footer';
import { useDispatch, useSelector } from "react-redux";
import { setCurMenuAction, setHeaderTransferAction } from "../../modules/common/headerModule";
import HoverLinkBtn from "../../components/common/button/HoverLinkBtn";
import CustomTitle from "../../components/common/title/CustomTitle";
import { Redirect, useHistory, useLocation } from "react-router-dom";
import MyClipMenuTab from "../../components/mp/MyClipMenuTab";
import { userClipAction, setSubMenuAction, setDefautlValueProductAction } from "../../modules/su/userInfoModule";
import { useState } from "react";
import MyClipBrand from "../../components/mp/MyClipBrand";
import MyClipProd from "../../components/mp/MyClipProd";
import MyClipSpace from "../../components/mp/MyClipSpace";
import { setReSetBrandClipResultAction } from '../../modules/common/brandModule';
import LoadingOverlay from 'react-loading-overlay';
import { isIE, isChrome, isMobileOnly } from "react-device-detect";

const MyClipBlock = styled.div`
`;

const MyClipWrapBlock = styled.div`
    
    ${isMobileOnly?`
       margin: 0 4vw; 
       padding: 120px 0 120px;    
  `:`
        width: 100%;
        max-width: 1176px;
        margin: 0 auto;
        padding: 140px 0 120px;
  `};

    ::after {
        content: "";
        display: block;
        clear: both;
    }
`;

const MyClipLnbBlock = styled.div`
    float: left;
    ${isMobileOnly?`
    width: 100%;     
  `:`
    width: 234px;
    padding-right: 40px;
  `};
    

    h2 {
        margin-bottom: 50px;
        font-size: 32px;
        font-weight: 700;
    }
`;

const MyClipLnbUlContainBlock = styled.div`
    ${isMobileOnly?`
    width: 100%;
    //overflow: scroll hidden;
    overflow-x: scroll;
    overflow-y: hidden;  
    height: 35px;
    margin-bottom: 10vw;
    border-bottom: 1px solid #111; 
  `:`
    
  `};
`;

const MyClipLnbLiBlock = styled.li`
    margin-bottom: 30px;
    color: #333;
    font-size: 20px;
    font-weight: 500;

    ${isMobileOnly&&"float: left"};
    ${isMobileOnly&&"margin-right: 4vw"};
`;

const MyClipContentsBlock = styled.div`
    float: left;
    //width: 936px;
    ${isMobileOnly?`
    width: 100%;
  `:`
    width: 936px;
  `};
`;

const StyleLoader = styled(LoadingOverlay)`
    padding:0px;
    margin : 0px;
    margin-top: 0px;
  .MyLoader_overlay {
    background: rgba(0, 0, 0, 0.1);
  }
  &.MyLoader_wrapper--active {
    overflow: hidden;
  }
`;

const VIEW_ALL = { brnd_id: 0, brnd_han: "전체보기", countprdt: 0 };

const MyClip = () => {

    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    //const [subMenu, setSubMenu] = useState(0);
    const [sortSave, setSortSave] = useState(0);

    const { loading, accessToken, code,
        clipinfo, brandClipResult, sort, brandClipAllDelResult, subMenu } = useSelector(
            ({ userReducer, loadingReducer, userInfoReducer, brandItemsReducer }) => ({
                loading: loadingReducer['userinfo/CLIP'],
                accessToken: userReducer.accessToken,
                code: userInfoReducer.code,
                clipinfo: userInfoReducer.clipinfo,
                brandClipResult: brandItemsReducer.brandClipResult,
                sort: userInfoReducer.sort,
                brandClipAllDelResult: brandItemsReducer.brandClipAllDelResult,
                subMenu: userInfoReducer.subMenu,
            })
        );

    useEffect(() => {
        dispatch(setCurMenuAction('myclip'));
        dispatch(setHeaderTransferAction(false));
        window.scrollTo(0, 0);

        setSortSave(sort);

        if (accessToken !== null) {
            if (history.action === 'PUSH' || clipinfo === null) {
                dispatch(userClipAction('sort=' + sort));
                dispatch(setSubMenuAction(0));
                dispatch(setDefautlValueProductAction(VIEW_ALL));
            }
        }
    }, []);

    useEffect(() => {
        // Token 만료
        if (code === 600) {
            // 홈으로 이동
            return history.push('/');
        }
    }, [code])

    useEffect(() => {
        // 삭제 후 재조회
        if (brandClipResult !== null || brandClipAllDelResult !== null) {
            dispatch(userClipAction('sort=' + sort));
            dispatch(setReSetBrandClipResultAction());
        }
    }, [brandClipResult, brandClipAllDelResult])

    useEffect(() => {
        if (sort !== sortSave) {
            dispatch(userClipAction('sort=' + sort));
            setSortSave(sort);
        }
    }, [sort])

    const menuTitle = [
        { title: '나의견적', link: '/es', isUnderLine: false },
        { title: '나의클립북', link: '/myclip', isUnderLine: true },
        { title: '회원정보관리', link: '/mysetting', isUnderLine: false },
        { title: '1:1 문의 내역', link: '/myquestion', isUnderLine: false }
    ]

    const handleMenuClick = (param) => {
        dispatch(setSubMenuAction(param));
    }

    const getContentsComp = () => {

        if (subMenu === 0) {
            return <MyClipBrand clipinfo={clipinfo} />
        } else if (subMenu === 1) {
            return <MyClipProd clipinfo={clipinfo} />
        } else {
            return <MyClipSpace clipinfo={clipinfo} />
        }
    }

    // 로그인 상태가 아니라면
    if (accessToken === null) {
        return <Redirect to="/" />
    }

    return (
        <MyClipBlock>
            <Header />
            <MyClipWrapBlock>
                <MyClipLnbBlock>
                    <h2>마이페이지</h2>
                    <MyClipLnbUlContainBlock>
                    <ul style = {isMobileOnly? {width:'max-content'}:{}}>
                        {
                            menuTitle.map((curitem, idx) => {
                                return (
                                    <MyClipLnbLiBlock key={idx}>
                                        <HoverLinkBtn
                                            text={curitem.title}
                                            bottom="2px"
                                            height="4px"
                                            link={curitem.link}
                                            isDot={false}
                                            isUnderLine={curitem.isUnderLine}
                                        >
                                        </HoverLinkBtn>
                                    </MyClipLnbLiBlock>
                                );
                            })
                        }
                    </ul>
                    </MyClipLnbUlContainBlock>
                </MyClipLnbBlock>
                <MyClipContentsBlock>
                <StyleLoader
                active={loading}
                //active = "true"
                spinner
                text=''
                classNamePrefix='MyLoader_'>
                    <CustomTitle marginBottom={isMobileOnly? "5vw":"58px"} textColor="#333"
                        fontSize="24px" fontWeight="300" title="나의 클립북" textAlign="left" />
                    <MyClipMenuTab active={subMenu}
                        clipinfo={clipinfo} clickHandler={handleMenuClick} />
                    {
                        getContentsComp()
                    }
                </StyleLoader>
                </MyClipContentsBlock>

            </MyClipWrapBlock>
            <Footer />
        </MyClipBlock>
    );
};

export default MyClip;
